const PLAYBACK_SYNC_EVENT = "spotify-panel:playback-sync";

export const requestPlaybackSync = (): void => {
  window.dispatchEvent(new Event(PLAYBACK_SYNC_EVENT));
};

export const subscribeToPlaybackSync = (listener: () => void): (() => void) => {
  window.addEventListener(PLAYBACK_SYNC_EVENT, listener);
  return () => window.removeEventListener(PLAYBACK_SYNC_EVENT, listener);
};
